import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimeComponent),
      multi: true,
    },
  ],
  standalone:false
})
export class DateTimeComponent {
  @Input() config: any;
  isOpen = false;
  @ViewChild('popover') popover: any;
  value = '';

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // Called by Angular when writing a value to the control
  writeValue(value: any): void {
    this.value = value;
  }

  // Registers a callback function that should be called when the value changes
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Registers a callback function that should be called when the control is touched
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Handles the `ionChange` event
  handleChange(event: any) {
    const selectedValue = event.detail.value; // Extract the value from event.detail
    this.value = selectedValue;
    this.onChange(selectedValue); // Notify the parent form control of the value change
    this.onTouched();
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }
}
